/* eslint-disable default-param-last */

import {setFleetAssetsTagsStatus } from '../../actions/common';
import saveFetch from '../../features/utils/saveFetch';
import { env } from '../../env';

const { TACHOGRAPH_SERVICES_SERVICE } = env.runtimeConfig.backend;

const getFleetAssetsTagStatus = (
    store,
    fetch = window.fetch,
) => () => fetch(
    `${TACHOGRAPH_SERVICES_SERVICE}/downloadscheduler/fleet-assets-tag-synced`,
    {
        headers: {
            Authorization: `Bearer ${`${store.getState().tokenHandling.accessToken}`}`,
        },
        method: 'GET',
    },
);

export const getHandleData = store => data => {
    store.dispatch(setFleetAssetsTagsStatus(data));
};

const configureFetchFleetAssetsTagStatus = store => new Promise(resolve => {
    const fleetAssetsTagStatus = getFleetAssetsTagStatus(store);

    saveFetch(
        fleetAssetsTagStatus,
        'Fleet Drivers Tags Status',
        getHandleData(store),
        resolve,
        () => {},
    );
});

export default configureFetchFleetAssetsTagStatus;
